module.exports = __webpack_public_path__ + "img/maison-2.19d86898.png";